<template>
  <div class="container">
    <nav class="navbar" role="navigation" aria-label="main navigation">
      <div class="navbar-brand">
        <a class="navbar-item">
          <img src="/logo-wewash.jpg" alt />
        </a>

        <a
          role="button"
          class="navbar-burger burger"
          :class="{'is-active' : openMenu}"
          @click="openMenu = !openMenu"
          aria-label="menu"
          aria-expanded="false"
          data-target="navbarBasicExample"
        >
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
      </div>

      <div id="navbarBasicExample" class="navbar-menu" :class="{'is-active' : openMenu}">
        <div class="navbar-start">
          <router-link tag="a" to="/" class="navbar-item">Головна</router-link>
          <router-link tag="a" to="/cards" class="navbar-item">Картки клієнтів</router-link>
          <router-link tag="a" to="/by-the-day" class="navbar-item">Облік по днях</router-link>
          <router-link tag="a" to="/services" class="navbar-item">Послуги</router-link>

          <div class="navbar-item has-dropdown is-hoverable" v-if="isAdmin">
            <a class="navbar-link">Інше</a>

            <div class="navbar-dropdown">
              <router-link tag="a" to="/bookkeeping" class="navbar-item">Облік</router-link>
              <!-- <a class="navbar-item">Jobs</a>
                    <a class="navbar-item">Contact</a>
                    <hr class="navbar-divider">
              <a class="navbar-item">Report an issue</a>-->
            </div>
          </div>
          <p @click="logoutHandle" class="navbar-item">Вихід</p>
        </div>

        <div class="navbar-end">
          <div class="navbar-item">
            <div class="buttons">
              <button @click="$emit('add')" class="button is-info">{{addName}}</button>
              <button @click="$emit('refresh')" class="button is-light">
                <b-icon icon="reload"></b-icon>
                <!-- <span>Обновить</span> -->
              </button>
            </div>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  props: {
    addName: {
      type: String,
      default: "Добавити"
    }
  },
  data() {
    return {
      openMenu: false
    };
  },
  computed: {
    ...mapGetters(["isAdmin"])
  },
  methods: {
    ...mapActions(["logout"]),
    logoutHandle() {
      this.logout().then(() => {
        this.$router.push("/login");
      });
    }
  }
};
</script>

